
























































import { Component, Mixins, Watch } from 'vue-property-decorator';
import { Button, Card, Form, FormItem, Option, Select } from 'element-ui';
import NullableInput from '@/components/element-ui/NullableInput.vue';
import UtcDatePicker from '@/components/element-ui/UtcDatePicker.vue';
import Milestone from '@/components/milestone/Milestone.vue';
import carriers from '@/mixins/carrierOptions.ts';

// services
import { shipmentService } from '@/services/ShipmentService';
import { milestoneService } from '@/services/MilestoneService';

// gql
import fetchMilestoneDetailsQuery from '@/graphql/queries/shipment/FetchMilestoneDetails.gql';

// types
import {
  ShipmentUpdateInput,
  ShipmentFields,
  MilestoneFields,
  MilestoneTypeEnum,
  MilestoneInput
} from '@/types/graphql/schemaTypes';

import draggable from 'vuedraggable';
import get from 'lodash/get';

@Component({
  apollo: {
    shipment: {
      query: fetchMilestoneDetailsQuery,
      prefetch: true,
      variables() {
        return {
          shipmentArgs: {
            shipmentId: this.$route.params.id
          }
        };
      },
      update(data) {
        this.setInput(data.shipments[0]);
        this.milestones = data.shipments[0].milestones;
        return data && data.shipments && data.shipments[0];
      }
    }
  },
  components: {
    draggable,
    Milestone,
    UtcDatePicker,
    'el-button': Button,
    'el-card': Card,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-input': NullableInput,
    'el-option': Option,
    'el-select': Select
  }
})
export default class Milestones extends Mixins(carriers) {
  private loading = false;
  private milestones: MilestoneFields[] = [];
  private shipment!: ShipmentFields;
  private shipmentInput: ShipmentUpdateInput = {
    id: '',
    carrierId: null,
    endFreeTime: null
  };

  private async addMilestone() {
    try {
      this.loading = true;

      const milestone: MilestoneInput = {
        milestoneType: MilestoneTypeEnum.pickup
      };
      const response = await milestoneService.createMilestone(milestone, this.shipment.id);

      if (response.data) {
        this.$apollo.queries.shipment.refetch();
        this.$store.dispatch('Alert/addAlert', {
          type: 'success',
          message: this.$t('success.created'),
          time: 2000
        });
      }
    } catch (error) {
      this.$store.dispatch('Alert/addAlert', {
        type: 'error',
        message: this.$t('error.push'),
        time: 2000
      });
    } finally {
      this.loading = false;
    }
  }

  private async reorder() {
    try {
      const response = await milestoneService.reorderMilestones(
        this.milestones.map(milestone => milestone.id),
        this.shipment.id
      );

      if (response) {
        this.$store.dispatch('Alert/addAlert', {
          type: 'success',
          message: this.$t('success.updated'),
          time: 2000
        });
      }
    } catch (error) {
      this.$store.dispatch('Alert/addAlert', {
        type: 'error',
        message: this.$t('error.push'),
        time: 2000
      });
    }
  }

  private setInput(shipment: ShipmentFields) {
    this.searchCarrier = (shipment.carrier && shipment.carrier.name) || '';
    this.setCarrierType(shipment.transportationType);
    this.shipmentInput = {
      id: shipment.id,
      carrierId: get(shipment, 'carrier.id', null),
      endFreeTime: shipment.endFreeTime
    };
  }

  // update carrier and end of free time date
  private async submit() {
    try {
      this.loading = true;

      const response = await shipmentService.updateShipment(this.shipmentInput);

      if (response) {
        this.$store.dispatch('Alert/addAlert', {
          type: 'success',
          message: this.$t('success.updated'),
          time: 2000
        });
      }
    } catch (error) {
      this.$store.dispatch('Alert/addAlert', {
        type: 'error',
        message: this.$t('error.push'),
        time: 2000
      });
    } finally {
      this.loading = false;
    }
  }
}
